module.exports = __webpack_public_path__ + "static/img/kasumi and kiyoshimo relaxing.161ea55.jpg";